<section class="flex justify-between gap-4 py-2 flex-col md:flex-row">
  <app-ticket-count-chart
    class="md:flex-1 flex flex-col self-center w-full px-4 md:pr-0 md:px-0 mt-4 md:mt-0"
    [tickets]="tickets"
    [isLoading]="isLoading"
    [ticketAggregate]="aggregate"
    (timeRangeChanged)="onTimeRangeChanged($event)"
  ></app-ticket-count-chart>
  <app-ticket-type-chart
    class="md:flex-1 self-center justify-center hidden md:flex w-full"
    [ticketAggregate]="aggregate"
    [isLoading]="isLoading"
    [tickets]="tickets"
  ></app-ticket-type-chart>
</section>
